module.exports = __webpack_public_path__ + "img/compass.b6b7ef7d.png";